var arslunaPortlet = function($) {
    "use strict";

    function init() {
        $(".arsluna-portlet")
            .addClass("arsluna-portlet-widget")
            .find(".arsluna-portlet-header")
            .addClass("arsluna-portlet-widget-header")
            .end()
            .find(".arsluna-portlet-content")
            .addClass("arsluna-portlet-widget-content")
            .wrapInner('<span class="title"></span>');
    } // END init

    function toggle(el) {
        $(el).toggleClass("portlet-closed").toggleClass("portlet-opened");
        $(el).parents(".arsluna-portlet:first").find(".arsluna-portlet-content").toggle('blind', 250);
    } // END toggle

    return {
        init  : init,
        toggle: toggle
    }
}(jQuery); // END arslunaPortlet

function responsiveTable(selector){
    var regex = /<br\s*[\/]?>/gi;
        var labels = {};
    $(selector).each(function(){
        labels = {};
        $(this).find('thead').find("th").each(function(index ){
            labels[index] = $(this).html().replace("&nbsp;"," ");
        });
        $(this).find('tbody').find("tr").each(function(){
            var tr = $(this),
                     label;
            tr.find("td").each(function(idx){
                label = labels[idx];
                label = label.replace(regex, " / ");
                $(this).attr("data-th",label);
            });
        });
    });
}

jQuery(document).ready(function($) {
    arslunaPortlet.init();
    $(".arsluna-portlet-header").click(function() {
        arslunaPortlet.toggle(this);
    }); // END portlet

    responsiveTable(".arsluna-responsive-table");
});
